import { useState } from 'react';
import styles from './App.module.css'
import poweredImage from './assets/mylogo.png';
import leftArrowImage from './assets/leftarrow.png';
import { GridItem } from './components/GridItem'; 

import { levels, calculateImc, Level } from './helpers/imc';


export default function App() {
  const [heightField, setHeightField] = useState<number>(0);
  const [weightField, setWeightField] = useState<number>(0);
  const [toShow, setToShow] = useState<Level | null>(null);
  
  const handleCalcularButton = () => {
    if (heightField && weightField) {
      // calculo do imc aqui
      setToShow(calculateImc(heightField, weightField));
    } else {
      alert("Digite todos os campos.");
    }

  }


  // botão de voltar
  const handleBackButton = () => {
    setToShow(null);
    setHeightField(0);
    setWeightField(0);
  }



  return (
    <div className={styles.main}>
      <header>
        <div className={styles.headerContainer}>
          <img src={poweredImage} alt="imagem logo" width={150} />
          
        </div>
      </header>

      <div className={styles.container}>
        <div className={styles.leftSide}>
          <h1>Calcule seu IMC.</h1>
          <p>
            IMC é a sigla para índice de Massa Corpórea, parâmetro
            adotado pela Organização Mundial de Saúde para calcular o peso ideal de cada pessoa
          
          </p>

          <input
           type="number"
           placeholder="Digite a sua altura . Ex: 1.5 (em metros)"
           value={heightField > 0 ? heightField : ''}
           onChange={e => setHeightField(parseFloat(e.target.value))}
           disabled={toShow ? true : false}
          />

          <input
           type="number"
           placeholder="Digite aseu peso . Ex: 75.3 (em Kg)"
           value={weightField > 0 ? weightField : ''}
           onChange={e => setWeightField(parseFloat(e.target.value))}
           disabled={toShow ? true : false}
          />

          <button onClick={handleCalcularButton} disabled={toShow ? true : false} >Calcular</button>

        </div>
        <div className={styles.rightSide}>
          {!toShow &&
            <div className={styles.grid}>
              {levels.map((item, key) => (
                <GridItem key={key} item={item} />
              ))}
            </div>
          }

          {toShow &&
            <div className={styles.rightBig}>
              <div className={styles.rightArrow} onClick={handleBackButton}>
                <img src={leftArrowImage} alt="" width={25} />
              </div>
              <GridItem item={toShow} />
            </div>
          }
       


        </div>

      </div>
    </div>
  );
}





